/* eslint-disable @typescript-eslint/dot-notation */
import { ChangeDetectionStrategy, Component, signal, ViewEncapsulation } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';
import { LetterCellEditorInlineComponent } from './letter-cell-editor-inline/letter-cell-editor-inline.component';
import { LetterCellEditorPopupComponent } from './letter-cell-editor-popup/letter-cell-editor-popup.component';

/**
 * Editor Custom AgGrid for text Input.
 * Params:
 * - notAdmissibleChars: (Optional) it allows to specify a set of not admissible chars to type. Ex.: ['<', '>', '(', ')'].
 * - inlineEditor (Default true) it allows to specify the preference between online or popup editor version.
 * - required: (Optional) It allows to specify required validator.
 */
export interface ILetterCellEditorParams {
    notAdmissibleChars?: string[];
    inlineEditor: boolean; // true di default;
    required?: boolean;
}
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-letter-cell-editor',
    templateUrl: './letter-cell-editor.component.html',
    styleUrls: ['./letter-cell-editor.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LetterCellEditorInlineComponent, LetterCellEditorPopupComponent],
})
export class LetterCellEditorComponent implements ICellEditorAngularComp {
    readonly editInline = signal<boolean>(false);
    readonly notAdmissibleChars = signal<string[]>([]);
    readonly cellWidth = signal<string>('');
    readonly cellStartEdited = signal<boolean>(false);
    readonly cellReady = signal<boolean>(false);
    readonly formControl: FormControl = new FormControl<string | null>(null);

    agInit(params: ICellEditorParams & ILetterCellEditorParams): void {
        this.cellWidth.set(params.column.getActualWidth() + 'px');
        this.cellStartEdited.set(params.cellStartedEdit);
        this.editInline.set(params.inlineEditor === false ? false : true);
        this.notAdmissibleChars.set(params.notAdmissibleChars ?? []);
        //this.inlineEditor = params.api.getEditingCells().length === 1 ? this.editInline : true;
        if (params.required) this.formControl.addValidators(Validators.required);
        this.formControl.setValue(params.value ?? null, { emitEvent: false });
        this.formControl.updateValueAndValidity({ emitEvent: false });
    }

    getValue(): string | null {
        return this.formControl.valid ? this.formControl.getRawValue() : null;
    }

    isCancelBeforeStart(): boolean {
        return false;
    }

    isPopup(): boolean {
        return !this.editInline();
    }

    afterGuiAttached(): void {
        this.cellReady.set(true);
    }
}
